'use strict';

(function ($, NSFD) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';
	var arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_left" /></svg></button>';
	var arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_right" /></svg></button>';
	var $map = location.pathname;

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	// ブランド
	var brandSlider = function brandSlider() {
		function brandSliderSetting() {
			var winW = $(window).width();
			if (winW >= 1025) {
				$('.idx-brand-slider').not('.slick-initialized').slick({
					infinite: true,
					speed: 1500,
					autoplay: true,
					autoplaySpeed: 5000,
					slidesToShow: 4,
					arrows: true,
					dots: false,
					prevArrow: arrowPrev,
					nextArrow: arrowNext
				});
			} else {
				$('.idx-brand-slider.slick-initialized').slick('unslick');
			}
		}
		brandSliderSetting();
		$(window).resize(function () {
			brandSliderSetting();
		});
	};

	// おすすめ商品サイト
	var recommendSlider = function recommendSlider() {
		$('.prod-idx-recommend-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 4,
			arrows: true,
			dots: false,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					appendArrows: $('.prod-idx-recommend-slider-arrows')
				}
			}]
		});
		$('.mod-boxLink03-txtBlock-tit').matchHeight();
		$('.mod-boxLink03-txtBlock-txt').matchHeight();
	};

	// 「カテゴリーから探す」カレント
	var categoryCurrent = function categoryCurrent() {
		if ($('.inc_foods_category').length) {
			$('.inc_foods_category').find('.mod-boxLink02-a').each(function (idx, ele) {
				var catUrl = $(ele).attr('href');
				if ($map.indexOf(catUrl) !== -1) {
					$(ele).addClass(a);
				}
			});
		}
	};

	var modalImg = function modalImg() {
		$('.mod-modal').on('click', function (e) {
			var HTML = '<div class="mod-modal-overlay">';
			HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#close" /></svg></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
			$('body').append(HTML);

			var $overlay = $('.mod-modal-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});
	};

	// アンケート用ポップアップバナー
	var popupBnr = function popupBnr() {
		var img = '<img src="/index/images/index/bnr_questionnaire01.jpg" alt="日清製粉ウェルナに関するアンケート">';
		var linkURL = void 0;
		var cookieName = 'questionnairePopupBnr-other';

		if ($map === '/index/' || $map === '/index/index.html' || $map === '/index/nisshin-seifun-welna/' || $map === '/index/nisshin-seifun-welna/index.html' || $map === '/index/recipe/' || $map === '/index/recipe/index.html' || $map === '/index/company/' || $map === '/index/company/index.html' || $map === '/index/sdgs/' || $map === '/index/sdgs/index.html' || $map === '/index/products/' || $map === '/index/products/index.html' || $map === '/index/mama/' || $map === '/index/mama/index.html' || $map === '/index/mama/thepasta/' || $map === '/index/mama/thepasta/index.html' || $map === '/index/mama/chomochi/' || $map === '/index/mama/chomochi/index.html' || $map === '/index/mama/pro-taste/' || $map === '/index/mama/pro-taste/index.html' || $map === '/index/mama/konabenipon/' || $map === '/index/mama/konabenipon/index.html' || $map === '/index/mama/yudemacaroni/' || $map === '/index/mama/yudemacaroni/index.html' || $map === '/index/nisshin/' || $map === '/index/nisshin/index.html' || $map === '/index/nisshin/cookingflower/' || $map === '/index/nisshin/cookingflower/index.html' || $map === '/index/nisshin/kameriya/' || $map === '/index/nisshin/kameriya/index.html' || $map === '/index/nisshin/breadmix/' || $map === '/index/nisshin/breadmix/index.html' || $map === '/index/nisshin/wb/' || $map === '/index/nisshin/wb/index.html' || $map === '/index/nisshin/rakuage/' || $map === '/index/nisshin/rakuage/index.html' || $map === '/index/nisshin/gp/' || $map === '/index/nisshin/gp/index.html' || $map === '/index/nisshin/jipai/' || $map === '/index/nisshin/jipai/index.html' || $map === '/index/nisshin/gokumix/' || $map === '/index/nisshin/gokumix/index.html' || $map === '/index/nisshin/off/' || $map === '/index/nisshin/off/index.html' || $map === '/index/nisshin/offmix/' || $map === '/index/nisshin/offmix/index.html' || $map === '/index/nisshin/konepan/' || $map === '/index/nisshin/konepan/index.html' || $map === '/index/nisshin/toromi/' || $map === '/index/nisshin/toromi/index.html') {

			// TOPページ
			if ($map === '/index/' || $map === '/index/index.html') {
				linkURL = 'https://fanbase-score.com/u/nswelna/?from=top';
			}

			// 新社名特移設ページ
			if ($map === '/index/nisshin-seifun-welna/' || $map === '/index/nisshin-seifun-welna/index.html') {
				linkURL = 'https://fanbase-score.com/u/nswelna/?from=nswelna';
			}
			// レシピTOP
			if ($map === '/index/recipe/' || $map === '/index/recipe/index.html') {
				linkURL = 'https://fanbase-score.com/u/nswelna/?from=recipe';
			}
			// 企業情報TOP
			if ($map === '/index/company/' || $map === '/index/company/index.html') {
				linkURL = 'https://fanbase-score.com/u/nswelna/?from=company';
			}
			// SDGsページ
			if ($map === '/index/sdgs/' || $map === '/index/sdgs/index.html') {
				linkURL = 'https://fanbase-score.com/u/nswelna/?from=sdgs';
			}
			// 商品情報TOP
			if ($map === '/index/products/' || $map === '/index/products/index.html') {
				linkURL = 'https://fanbase-score.com/u/nswelna/?from=products';
			}

			// 【マ・マ―】 -------------------------------------------------------------
			if ($map.indexOf('/index/mama/') !== -1) {
				img = '<img src="/index/images/index/bnr_questionnaire02.jpg" alt="マ・マーブランドに関するWEBアンケート">';
				cookieName = 'questionnairePopupBnr-mama';
				linkURL = 'https://fanbase-score.com/u/mama/?from=web';
			}

			// 【日清】 -------------------------------------------------------------
			if ($map.indexOf('/index/nisshin/') !== -1) {
				img = '<img src="/index/images/index/bnr_questionnaire03.jpg" alt="日清ブランドに関するWEBアンケート">';
				cookieName = 'questionnairePopupBnr-nisshin';
				linkURL = 'https://fanbase-score.com/u/nisshin/?from=web';
			}

			var bnrHTML = '<div class="mod-popupBnr js-questionnaire-popupBnr"><span class="mod-popupBnr-close"><span class="mod-popupBnr-close-inner">' + '<svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#close"></use></svg></span></span>' + '<a href="' + linkURL + '" target="_blank" class="mod-popupBnr-link">' + img + '</a></div>';

			var cookieIf = document.cookie.indexOf(cookieName);
			if (cookieIf == -1) {
				;
				$(document).ready(function () {
					$('body').prepend(bnrHTML);
				});
			}

			// 閉じるボタンクリック & バナークリック
			$(document).on('click', '.js-questionnaire-popupBnr .mod-popupBnr-close, .js-questionnaire-popupBnr .mod-popupBnr-link', function (event) {
				$('.js-questionnaire-popupBnr').addClass('di_none');
				var now = new Date();
				now.setDate(now.getDate() + 30);
				document.cookie = cookieName + '=true;expires=' + now.toUTCString() + ';path=/;';
			});
		}
	};

	// 大谷翔平POPアップバナー(商品情報配下のみ表示)
	var campaignPopupBnr = function campaignPopupBnr() {
		// let checkedLen = $('.recipe-search__detailSearch input[checked="checked"]').length;

		if ($map.indexOf('/index/products/') === 0 || $map === '/index/recipe/' || $map === '/index/recipe/index.html' || $map === '/index/recipe/search.html') {
			if (!$map.includes('/index/products/cookingmix/') && !$map.includes('/index/products/breadcrumbs/') && !$map.includes('/index/products/cooking_sause/') && !$map.includes('/index/products/noodle/') && !$map.includes('/index/products/frozen_snack/') && !$map.includes('/index/products/frozen_others/')) {
				var cookieName = 'popupBnr-otani';
				var img = '<img src="/index/release/news_file/file/250218_welna_pc_topbur.jpg" alt="大谷翔平×日清製粉ウェルナ　いいもの、食べよう。">';
				var linkURL = '/index/welna/';
				var bnrHTML = '<div class="mod-popupBnr js-questionnaire-popupBnr"><span class="mod-popupBnr-close"><span class="mod-popupBnr-close-inner">' + '<svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#close"></use></svg></span></span>' + '<a href="' + linkURL + '" target="_blank" class="mod-popupBnr-link">' + img + '</a></div>';

				var cookieIf = document.cookie.indexOf(cookieName);
				if (cookieIf == -1) {
					;
					$(document).ready(function () {
						$('body').prepend(bnrHTML);
					});
				}
				// 閉じるボタンクリック & バナークリック
				$(document).on('click', '.js-questionnaire-popupBnr .mod-popupBnr-close, .js-questionnaire-popupBnr .mod-popupBnr-link', function (event) {
					$('.js-questionnaire-popupBnr').addClass('di_none');
					var now = new Date();
					now.setDate(now.getDate() + 1);
					document.cookie = cookieName + '=true;expires=' + now.toUTCString() + ';path=/;';
				});
			}
		}
	};

	// ジョブチューンポップアップバナー（amazonへのリンク）
	var amazonPopupBnr = function amazonPopupBnr() {
		if ($map.indexOf('/index/') === 0) {
			var cookieName = 'popupBnr-amazon';
			var img = '<img src="/index/images/index/bnr_popup.png" alt="ジョブチューンに登場しました！">';
			var linkURL = 'https://www.amazon.co.jp/stores/page/2BE0A87E-7BFB-4B68-BC50-EB93FF085053?channel=job20250315_hp_popup';
			var bnrHTML = '<div class="mod-popupBnr js-questionnaire-popupBnr"><span class="mod-popupBnr-close"><span class="mod-popupBnr-close-inner">' + '<svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#close"></use></svg></span></span>' + '<a href="' + linkURL + '" target="_blank" class="mod-popupBnr-link">' + img + '</a></div>';

			var cookieIf = document.cookie.indexOf(cookieName);
			if (cookieIf == -1) {
				;
				$(document).ready(function () {
					$('body').prepend(bnrHTML);
				});
			}
			// 閉じるボタンクリック & バナークリック
			$(document).on('click', '.js-questionnaire-popupBnr .mod-popupBnr-close, .js-questionnaire-popupBnr .mod-popupBnr-link', function (event) {
				$('.js-questionnaire-popupBnr').addClass('di_none');
				var now = new Date();
				now.setDate(now.getDate() + 1);
				document.cookie = cookieName + '=true;expires=' + now.toUTCString() + ';path=/;';
			});
		}
	};

	removeElmIfEmpty();
	removeBlockIfListEmpty();

	// アンケート用ポップアップバナー
	// popupBnr();

	// 大谷翔平POPアップバナー
	// campaignPopupBnr();
	// ジョブチューンポップアップバナー（amazonへのリンク）
	// amazonPopupBnr();

	if ($('.mod-modal').length) {
		modalImg();
	}

	$(document).ready(function () {
		if ($('.idx-brand-slider').length) {
			brandSlider();
			$('.idx-brand-slider').addClass(v);
		}

		// if($('.prod-idx-recommend-slider').length) {
		// 	recommendSlider();
		// 	$('.prod-idx-recommend-slider').addClass(v);
		// }

		categoryCurrent();
	});
})(window.jQuery, window.NSFD);